	import { Component, EnumsService, BaseTLDetailComponent, AxiosResponse } from "../../../Infrastructure/CorBase/CoreBase";

	@Component
	export default class EnumDetailBase extends BaseTLDetailComponent {

		returnRoute: string = "EnumList";
		allowChangeUrlAfterCreate = false;

		formData = {
			id: 0,
			idTenant: 0,
			idGroup: 0,
			name: '',
			description: '',
			identifier: '',
			order:  null as any
		};
		enumsService: EnumsService = new EnumsService();
		protected isEditable = true;
	
		createdBase() {
			this.enumsService.getEnumIsEditable(String(this.$route.query.identifier), this.$store.state.idTenant).then((res: any) => {
				this.isEditable = res.data == true;
			});
		}

		///hlaska o prekroceni inputu po Ctrl+V
		protected infoShortInputBase(maxLength: string): void {
			this.showAlertModalWithTitleAndContent(this.$t('global.messageInfo').toString(), this.$t('global.messageShortInput').toString() + maxLength + this.$t('global.messageShortInput2').toString());
		}

		doAction() {
			super.doCRUDActionWithInfoMessage(this.$t('enum.messageNew').toString(), this.$t('enum.messageEdit').toString(), this.$t('enum.messageDelete').toString());
		}

		protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
			return this.enumsService.getById(this.objectId);
		}

		protected fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			return super.NoCall()
		}

		protected refreshItems(items: any, refreshData: any): any {
			return items;
		}

		protected processResponse(response: AxiosResponse<any>): void {
			this.formData.idGroup = response.data.idGroup;
			this.formData.id = response.data.id;
			this.formData.name = response.data.name;
			this.formData.description = response.data.description;
			this.formData.identifier = response.data.identifier;
			this.formData.order = response.data.order;
		}

		protected updateObject(): Promise<AxiosResponse<any>> {
			this.formData.order = this.formData.order == 0 ? null : Number(this.formData.order);
			return this.enumsService.update(this.objectId, this.formData);
		}

		updateBase() {
			this.enumsService.update(this.objectId, this.formData).then(res => {

				if (res.data.isSuccess == false) {
					this.showAlertModalWithTitleAndContent(this.$t('global.titleError').toString(), res.data.errorMessage);
				}
				else {
					this.showAlertModalWithInfoMessage(this.$t('enum.messageEdit').toString());
					this.formIsInEditMode = false;
				}
			});
		}
		
		protected createObject(): Promise<AxiosResponse<any>> {		
			this.formData.idGroup = Number(this.$route.query.idGroup);
			this.formData.idTenant = this.$store.state.idTenant;
			this.formData.order = this.formData.order == 0 ? null : Number(this.formData.order);
			return this.enumsService.create(this.formData);
		}

		protected afterCreate(response: AxiosResponse<any>): void {
			this.formData.id = response.data.id;
			this.formData.identifier = response.data.identifier;
			this.formData.order = response.data.order;
			var namePage = this.$route.name == undefined ? '' : this.$route.name;
			var newQuery = {};
			this.$store.commit("mainDataChanged", false);
			newQuery = { id: this.formData.id, identifier: this.$route.query.identifier };
			this.$router.replace({ name: namePage, query: newQuery });
		}


		protected deleteObject(): Promise<AxiosResponse<any>> {
			return this.enumsService.delete(this.objectId);
		}

		get showEditButtonChild() {
			return this.isEditable && this.showEditButton;
		}

		get showSaveButtonChild() {
			return this.isEditable && this.showSaveButton;
		}

		get showDeleteButtonChild() {
			return this.isEditable && this.showDeleteButton;
		}
		
		vCorrectOrder: boolean = true;
		vCorrectName: boolean = true;
		vCorrectIdentif: boolean = true;
		vCorrectDescription: boolean = true;

		isCorrectDescription(value: any) {
			this.vCorrectDescription = value;
		}

		isCorrectName(value: any) {
			this.vCorrectName = value;
		}

		isCorrectIdentif(value: any) {
			this.vCorrectIdentif = value;
		}

		isCorrectOrder(value: any) {
			this.vCorrectOrder = value;
		}

		validate() {
			return !(this.vCorrectDescription && this.vCorrectName);// && this.vCorrectOrder);
		}

	}

